function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28 4.67529H12C9.78 4.67529 8 6.45529 8 8.67529V40.6753C8 41.7362 8.42143 42.7536 9.17157 43.5037C9.92172 44.2539 10.9391 44.6753 12 44.6753H36C37.0609 44.6753 38.0783 44.2539 38.8284 43.5037C39.5786 42.7536 40 41.7362 40 40.6753V16.6753L28 4.67529ZM25.08 39.4153V35.4153H17.08V31.4353H25.08V27.4353L31.08 33.4353L25.08 39.4153ZM26 18.6753V7.67529L37 18.6753H26Z",
  fill: "#262DAA"
});

var SvgMdiFileSend = function SvgMdiFileSend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMdiFileSend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mdi_file-send.12d13928.svg";
export { ForwardRef as ReactComponent };